import { SET_NOTIFICATION } from "app/utils/constants/appActions";
import { store } from "../store";

export const setNotification = (data) => {
    store.dispatch({
        type: SET_NOTIFICATION,
        payload: data
    })
}
